function Registration() {
    return <h2>Registration</h2>;
}

export default Registration;
